"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatorsToObject = void 0;
// eslint-disable-next-line import/prefer-default-export
function validatorsToObject(validators) {
    return validators.reduce((prev, { name, regex }) => ({
        ...prev,
        [`data-validate-${name}`]: regex
    }), {});
}
exports.validatorsToObject = validatorsToObject;
